'use client';

import { MarketType } from '@drift-labs/sdk';
import { MARKET_UTILS } from '@drift/common';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftClientIsReady from './useDriftClientIsReady';

const DEFAULT_STATE = {
	maxLeverage: 0,
	highLeverageMaxLeverage: 0,
	hasHighLeverage: false,
};

const useMarketMaxLeverage = (
	marketType: MarketType,
	marketIndex: number | undefined
) => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const driftClientIsReady = useDriftClientIsReady();

	if (
		!driftClientIsReady ||
		!driftClient ||
		!driftClient.isSubscribed ||
		marketIndex === undefined
	) {
		return DEFAULT_STATE;
	}

	return MARKET_UTILS.getMaxLeverageForMarket(
		marketType,
		marketIndex,
		driftClient
	);
};

export default useMarketMaxLeverage;
